import type { GameModule } from '../types';
import Page from './Page';

const chess: GameModule = {
  id:          'chess',
  displayName: 'Chess',
  tag:         'Strategy',
  theme: {
    // Wood gradient for the dashboard tile — deliberately distinct
    // from Ludo's purple / Rummy's green / X&O's teal so the four
    // games read as four different identities at a glance.
    gradient: 'from-[#b58863] to-[#3a2515]',
    emoji:    '♞',
    logo:     '/games/chess/Logo.png',
  },
  // 8×8 board + captured-pieces side panels are laid out vertically;
  // landscape would crop the captured panel or shrink the board.
  orientation: 'portrait',
  Page,
  adminIcon: 'chess',
  adminTheme: {
    headerFrom:   'from-[#5a3f26]',
    headerTo:     'to-[#2b1a0e]',
    ring:         'ring-[#f6d07c]',
    accent:       'bg-[#8b6636]',
    accentHover:  'hover:bg-[#a66a2a]',
    dot:          'bg-[#f6d07c]',
    softBg:       'bg-[#5a3f26]/30',
    rangeAccent:  'accent-[#f6d07c]',
    badgeClasses: 'bg-[#8b6636]/20 text-[#f6d07c] border-[#8b6636]/30',
  },
};

export default chess;
